/* ==========================================================================
   Aori K Beauty — testimonials.js
   - Horizontal carousel: prev/next arrows (desktop), native touch scroll
     (mobile), and pointer drag (mouse). Arrows disable at the ends.
   - Lightbox: a testimonial's ▶ opens its video with sound. Supports a direct
     MP4 / Shopify-hosted file (<video>) or a YouTube/Vimeo URL (<iframe>).
     The media is created on click and removed on close (stops playback).
   ========================================================================== */
(function () {
  'use strict';

  /* ---- Carousel -------------------------------------------------------- */

  function step(track) {
    var slide = track.querySelector('.tst__slide');
    if (!slide) return track.clientWidth * 0.8;
    var st = getComputedStyle(track);
    var gap = parseFloat(st.columnGap || st.gap || 0) || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  function initCarousels() {
    document.querySelectorAll('[data-tst-track]').forEach(function (track) {
      if (track.dataset.tstReady) return;
      track.dataset.tstReady = '1';

      var sec = track.closest('.tst');
      var prev = sec && sec.querySelector('[data-tst-prev]');
      var next = sec && sec.querySelector('[data-tst-next]');

      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        var atEnds = max <= 2;
        // No overflow → center the cards; otherwise left-align + scroll.
        track.classList.toggle('is-centered', atEnds);
        if (prev) { prev.classList.toggle('is-hidden', atEnds); prev.disabled = track.scrollLeft <= 2; }
        if (next) { next.classList.toggle('is-hidden', atEnds); next.disabled = track.scrollLeft >= max; }
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(track), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(track), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);

      // Pointer drag for mouse users (touch already scrolls natively).
      var down = false, startX = 0, startLeft = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = startLeft - dx;
      });
      function end() { down = false; track.classList.remove('is-dragging'); }
      track.addEventListener('pointerup', end);
      track.addEventListener('pointerleave', end);
      // Swallow the click that follows a drag so it doesn't trigger the ▶.
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);

      update();
    });
  }

  /* ---- Lightbox -------------------------------------------------------- */

  var box, frame;

  function toEmbed(url) {
    url = (url || '').trim();
    var yt = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/|live\/)|youtu\.be\/)([\w-]{6,})/);
    if (yt) return { type: 'iframe', src: 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0&playsinline=1' };
    var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) return { type: 'iframe', src: 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1' };
    return { type: 'file', src: url };
  }

  function build() {
    if (box) return;
    box = document.createElement('div');
    box.className = 'tst-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.innerHTML = '<div class="tst-lightbox__frame"><button type="button" class="tst-lightbox__close" aria-label="Cerrar">✕</button></div>';
    frame = box.querySelector('.tst-lightbox__frame');
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    box.querySelector('.tst-lightbox__close').addEventListener('click', close);
    document.body.appendChild(box);
  }

  function clearMedia() {
    var m = frame.querySelector('iframe, video');
    if (m) m.remove();
  }

  function open(opts) {
    if (!opts || !opts.src) return;
    build();
    clearMedia();
    var el;
    if (opts.type === 'iframe') {
      el = document.createElement('iframe');
      el.src = opts.src;
      el.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
      el.setAttribute('allowfullscreen', '');
    } else {
      el = document.createElement('video');
      el.src = opts.src;
      el.controls = true;
      el.autoplay = true;
      el.playsInline = true;
    }
    frame.appendChild(el);
    box.classList.add('is-open');
    document.body.classList.add('no-scroll');
  }

  function close() {
    if (!box) return;
    box.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    clearMedia();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-tst-play]');
    if (!t) return;
    e.preventDefault();
    var file = t.getAttribute('data-video-file');
    if (file) open({ type: 'file', src: file });
    else open(toEmbed(t.getAttribute('data-video-url')));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* ---- Boot ------------------------------------------------------------ */

  if (document.readyState !== 'loading') initCarousels();
  else document.addEventListener('DOMContentLoaded', initCarousels);
  document.addEventListener('shopify:section:load', initCarousels);
})();
